"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var ReactDOM = require("react-dom");
var React = require("react");
var styles = require("./index.scss");
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.info = function (config) {
        if (typeof config === "string") {
            modal({ content: config });
        }
        else {
            modal(config);
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, children = _a.children, footer = _a.footer, style = _a.style, okText = _a.okText, onOk = _a.onOk, onCancel = _a.onCancel, visible = _a.visible, width = _a.width;
        var show = visible ? styles.show : "";
        return (React.createElement("div", { className: styles.wrapper + " " + show },
            React.createElement("div", { className: styles.cell },
                React.createElement("div", { style: __assign(__assign({}, style), { width: width }), className: styles.container + " " + show },
                    React.createElement("img", { src: require("./close.png"), className: styles.closeBTN, onClick: onCancel, alt: "" }),
                    React.createElement("div", { className: styles.content }, children),
                    footer === undefined ? (React.createElement("a", { onClick: onOk, className: styles.okBTN }, okText)) : (footer)))));
    };
    Modal.defaultProps = {
        visible: false,
        showClose: true,
        okText: "Confirm",
        width: 660
    };
    return Modal;
}(React.Component));
exports.Modal = Modal;
function modal(config) {
    var div = document.createElement("div");
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
    }
    function onCancel() {
        var onCancel = config.onCancel;
        if (typeof onCancel === "function") {
            onCancel();
        }
        close();
    }
    function onOK() {
        var onOK = config.onOK;
        if (typeof onOK === "function") {
            onOK();
        }
        close();
    }
    var footer = config.footer, content = config.content, okText = config.okText, width = config.width, style = config.style;
    ReactDOM.render(React.createElement(Modal, { visible: true, style: style, width: width || 420, okText: okText || "Confirm", footer: footer, onCancel: onCancel, onOk: onOK }, content), div);
}
exports.default = Modal;
